var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.isAvailable
    ? _c(
        "div",
        [
          _c(
            "b-btn",
            {
              staticClass: "btn-card-action btn-card-action-green my-1",
              on: { click: _vm.prePublish },
            },
            [_vm._v("Опубликовать")]
          ),
          _c(
            "b-modal",
            {
              ref: "publish-modal",
              attrs: {
                centered: "",
                "hide-header-close": "",
                "no-close-on-backdrop": "",
                "no-close-on-esc": "",
                size: "lg",
                title: _vm.title,
              },
              on: { hidden: _vm.clearEmails },
              model: {
                value: _vm.isModalVisible,
                callback: function ($$v) {
                  _vm.isModalVisible = $$v
                },
                expression: "isModalVisible",
              },
            },
            [
              _c(
                "b-form-group",
                { staticClass: "w-100", attrs: { state: !!_vm.emails.length } },
                [
                  _c("div", { staticClass: "d-block text-left mb-3" }, [
                    _vm._v(
                      "Выберите или введите почтовые ящики поставщиков, на них будут отправлены приглашения к закупке."
                    ),
                  ]),
                  _c(
                    "multiselect",
                    {
                      class: {
                        "is-valid": _vm.emails.length,
                        "is-invalid": !_vm.emails.length,
                      },
                      attrs: {
                        id: "org-select",
                        "close-on-select": true,
                        "clear-on-select": true,
                        "internal-search": false,
                        loading: _vm.isLoading,
                        multiple: true,
                        options: _vm.organizations,
                        "options-limit": 100,
                        "preserve-search": false,
                        taggable: true,
                        "deselect-label": "Отменить",
                        label: "name",
                        placeholder:
                          "Выберите организации / укажите адреса электронной почты",
                        "select-label": "Выбрать",
                        "selected-label": "Выбрано",
                        "tag-placeholder": "Добавить",
                        "track-by": "id",
                      },
                      on: { tag: _vm.addTag, "search-change": _vm.asyncFind },
                      model: {
                        value: _vm.emails,
                        callback: function ($$v) {
                          _vm.emails = $$v
                        },
                        expression: "emails",
                      },
                    },
                    [
                      _c(
                        "span",
                        { attrs: { slot: "noOptions" }, slot: "noOptions" },
                        [_vm._v("Нет данных.")]
                      ),
                      _c(
                        "span",
                        { attrs: { slot: "noResult" }, slot: "noResult" },
                        [
                          _vm._v(
                            "Записей, соответствующих вашему запросу, не найдено."
                          ),
                        ]
                      ),
                    ]
                  ),
                  !_vm.emails.length
                    ? [
                        _c(
                          "b-form-invalid-feedback",
                          { attrs: { "force-show": "" } },
                          [_vm._v("Поле обязательно для заполнения")]
                        ),
                      ]
                    : _vm._e(),
                ],
                2
              ),
              _c(
                "div",
                {
                  staticClass: "w-100 text-",
                  attrs: { slot: "modal-footer" },
                  slot: "modal-footer",
                },
                [
                  _c(
                    "b-overlay",
                    {
                      staticClass: "d-inline-block",
                      attrs: {
                        show: _vm.isDataSending,
                        opacity: "0.6",
                        rounded: "",
                        "spinner-small": "",
                        "spinner-variant": "primary",
                      },
                    },
                    [
                      _c(
                        "b-button",
                        {
                          staticClass: "text-uppercase mr-2",
                          attrs: { variant: "custom-outline-secondary" },
                          on: { click: _vm.cancelModal },
                        },
                        [_vm._v("Отмена")]
                      ),
                    ],
                    1
                  ),
                  _c(
                    "b-overlay",
                    {
                      staticClass: "d-inline-block",
                      attrs: {
                        show: _vm.isDataSending,
                        opacity: "0.6",
                        rounded: "",
                        "spinner-small": "",
                        "spinner-variant": "primary",
                      },
                    },
                    [
                      _c(
                        "b-button",
                        {
                          staticClass: "text-uppercase",
                          attrs: {
                            disabled: !_vm.emails.length,
                            variant: "custom-green",
                          },
                          on: { click: _vm.publishPurchase },
                        },
                        [_vm._v("Опубликовать")]
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }